<template>
  <ListView
    title="Table Applications"
    @reload="reload"
    @navDetails="actionDetails"
    :data="data"
    :page.sync="page"
    :header="header"
    :enableCreate="false"
  >
    <template v-slot:searchBox>
      <!-- Disable search by providing empty slot -->
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip :color="getStatusColor(item.status)" text-color="white" small>
        {{ getStatusText(item.status) }}
      </v-chip>
    </template>

    <template v-slot:item.owner="{ item }">
      {{ get(item, 'owner.name', '-') }}
    </template>

    <template v-slot:item.tableManagement="{ item }">
      {{ get(item, '_tableManagement.location', 'N/A') }}
    </template>

    <template v-slot:item.preferDateRange="{ item }">
      <span v-if="item.preferDateRange">
        {{ item.preferDateRange.startDate | moment }} - {{ item.preferDateRange.endDate | moment }}
      </span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | moment }}
    </template>
  </ListView>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import { tableApplicationStatusOption } from '@/data/optionsConstants';
import listViewPageMixin from '@/services/listViewPageMixin';
import { get } from 'lodash';

export default {
  name: 'IdentityApplicationsList',
  props: {
    profileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      header: [
        { text: 'Owner', value: 'owner' },
        { text: 'Table', value: 'tableManagement' },
        { text: 'Status', value: 'status' },
        { text: 'Prefer Date Range', value: 'preferDateRange' },
        { text: 'Applied At', value: 'createdAt' },
        { text: 'Remark', value: 'remark' },
      ],
      sort: { createdAt: -1 },
      populate: 'owner',
      tableApplicationStatusOption,
    };
  },
  mixins: [listViewPageMixin],
  computed: {
    restfulURL() {
      return RESTFUL.tableApplications.list;
    },
    filter() {
      return {
        owner: this.profileId,
      };
    },
  },
  methods: {
    get,
    actionDetails(item) {
      if ((item && item.tableManagement, item.tableManagement._id)) {
        this.$router.push({
          name: 'table',
          params: { id: item.tableManagement._id },
        });
      }
    },
    getStatusColor(status) {
      const statusColors = {
        pending: 'orange',
        approved: 'green',
        rejected: 'red',
        cancelled: 'grey',
      };
      return statusColors[status] || 'grey';
    },
    getStatusText(status) {
      const option = this.tableApplicationStatusOption.find(opt => opt.value === status);
      return option ? option.text : status;
    },
  },
};
</script>
